var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.05392 24.7768L14.628 5.48664C15.2495 4.4509 16.7506 4.4509 17.372 5.48665L28.9461 24.7768C29.586 25.8432 28.8178 27.2 27.5741 27.2H4.42591C3.18224 27.2 2.41406 25.8432 3.05392 24.7768ZM16 10.4C16.8837 10.4 17.6 11.1163 17.6 12V16.8C17.6 17.6837 16.8837 18.4 16 18.4C15.1164 18.4 14.4 17.6837 14.4 16.8V12C14.4 11.1163 15.1164 10.4 16 10.4ZM18 21.6C18 20.4954 17.1046 19.6 16 19.6C14.8954 19.6 14 20.4954 14 21.6V21.616C14 22.7206 14.8954 23.616 16 23.616C17.1046 23.616 18 22.7206 18 21.616V21.6Z",
    fill: "#FF9558"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.43fbbb17f4c6dff6729deaad039a4588.svg";
export { ForwardRef as ReactComponent };